import React from 'react'
import RegisterForm from './RegisterForm'

export default function RegisterPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   {/* <PageTitle
         breadcrumbs={[{title: 'sdf', path: 'login', isActive: false}]}
         description='Welcome'
       >
         Welcome Page
       </PageTitle> */}
   <RegisterForm />
  </>
 )
}
